import React, { Dispatch } from 'react';

import { useHistory } from 'react-router-dom';

import { Box } from '@waglabs/box-next';
import { Button } from '@waglabs/button-next';
import { Typography } from '@waglabs/typography';

import {
  DataTestIds,
  ROUTE_LOGIN,
} from '../../../../../../../constants';
import { WithHistoryInjectedProps } from '../../../../../../../hocs';
import { WagKeyIllustrationIcon } from '../../../../../../../icons';
import { useIsInEmbed } from '../../../../../../../hooks';


export type LinkAccountsModalProps = {
  onSignInClick?: () => void;
  signInCtaProps?: Record<string, string>;
  onCancelClick: () => void;
};

export const ConflictModalContent = ({
  onSignInClick,
  onCancelClick,
  signInCtaProps,
}: LinkAccountsModalProps) => (
  <Box
    data-testId={DataTestIds.Signup.OwnerInfoPage.ConflictModal}
    display="grid"
    alignItems="center"
    justifyItems="center"
    p="20px"
  >
    <WagKeyIllustrationIcon
      width="200px"
      height="150px"
    />
    <Typography
      textAlign="center"
      fontSize={['30px', '38px']}
      lineHeight="37px"
      fontFamily="Muli SemiBold"
    >
      Already have a Wag! account?
    </Typography>
    <Typography
      textAlign="center"
      fontSize={['20px', '22px']}
      lineHeight="25px"
    >
      There&apos;s already a Wag! account with your
      email, go back to sign in and link your accounts
    </Typography>
    <Box
      width="100%"
      gridTemplateColumns={['4.7fr 90.6fr 4.7fr', '8fr 84fr 8fr']}
      display="grid"
    >
      <Button
        gridColumn="2/span 1"
        variant="contained"
        height="56px"
        fontFamily="Muli Bold"
        marginBottom="8px"
        onClick={onSignInClick}
        {...signInCtaProps}
      >
        Back to Sign-in
      </Button>

      <Button
        height="56px"
        fontFamily="Muli Bold"
        gridColumn="2/span 1"
        variant="outlined"
        onClick={onCancelClick}
      >
        Cancel
      </Button>
    </Box>
  </Box>
);
